import { Typography, Row, Col, Tag }  from 'antd'
import Breakpoint from "../../enums/breakpoint.enum";
import useWidth from '../../hooks/useWidth.hook';
import { UserContext } from "../../contexts/user.context";
import { useContext } from "react";

const { Text, Paragraph } = Typography

export const SpermTestIntro = ({ footer, productType }) => {
  const width = useWidth()
  const { instalabMembership } = useContext(UserContext);

  const instructions = [{
    sections: [
      {
      title: 'Get Your Collection Kit',
      description: <>Through our lab partner, Legacy, you'll receive your kit within one week. This includes everything you'll need to collect your specimen and send to lab.</>
    }, 
  ]}, 
  {
    sections: [{
      title: 'Self Collect + Mail Back',
      description: <>Produce your sample by ejaculating directly into the sperm collection cup, without using lubricant or saliva. You don't need to fill the cup.</>
    }]
  }, 
  {
    sections: [{
      title: 'View Results Online',
      description: <>Test results will be ready 1 week after your sample arrives at the lab.</>
    }]
  }]

  return (
    <div 
      className="flow-intro"
      style={{
        minHeight: width >= Breakpoint.XL ? 'calc(100vh - 86px)' : 'calc(100vh - 60px)',
      }}
    >


      <div 
        className="flow-intro-body"
        style={{
          minHeight: width >= Breakpoint.XL ? 'calc(100vh - 86px)' : 'calc(100vh - 60px)',
        }}
      >
        <Paragraph 
          className="flow-title"
          style={{
            fontSize: width > Breakpoint.SM ? 32 : 28,
          }}
        >
          {productType?.title} - {instalabMembership ? `$${productType?.memberCost}` : `$${productType?.cost}`}
        </Paragraph>
        <Paragraph 
          className="flow-description"
        >
          {productType?.tagline}
        </Paragraph>

        <div 
          className="instruction-list"
          style={{
            marginTop: width > Breakpoint.SM ? 50 : 30,
            marginBottom: width > Breakpoint.SM ? -15 : -25,
            paddingTop: width > Breakpoint.SM ? 25 : 15,
          }}
        >
          {instructions.map(({ sections }, instructionIndex) => (
            <div 
              key={`instruction-${instructionIndex}`} 
              className="instruction-item"
            >
              <Row>
                <Col
                  style={{
                    width: width > Breakpoint.SM ? 80 : '100%',
                    marginBottom: width > Breakpoint.SM ? 0 : 10
                  }}
                >
                  <Text className="instruction-index">
                    Step {instructionIndex+1}
                  </Text>
                </Col>

                <Col
                  style={{
                    width: width > Breakpoint.SM ? 'calc(100% - 80px)' : '100%'
                  }}
                >
                  {sections.map(({ title, description }, sectionIndex) => (
                    <div 
                      key={`section-${instructionIndex}-${sectionIndex}`} 
                      className="section-item"
                    >
                      <Text className="section-title">
                        {title}
                      </Text>
                      <Paragraph className="section-description">
                        {description}
                      </Paragraph>
                    </div>
                  ))}
                  </Col>
              </Row>
            </div>
          ))}
        </div>

        <div className="flow-intro-btn-container">
          <div className="flow-intro-btn">
            {footer({ 
              buttonText: "Let's go",
              buttonCheck: false,
              buttonStyle: {
                height: 50,
                fontSize: 18,
                width: '100%',
                display: 'block',
              },
              enterStyle: {
                display: 'none',
              }
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

